<template>
  <div v-bind="$attrs">
    <div class="testStyle">
      This is a normal vue component using the <a href="https://vuejs.org/api/sfc-script-setup.html">Composition API
      with setup script.</a>
    </div>

    Count: {{ count }}
    <a class="myFirstRodeo-button" @click="count++">Add</a>&nbsp;
    <a class="myFirstRodeo-button" @click="count--">Subtract</a>

    <div class="row">
      <div class="col">
        <button @click="writeToConsole()" class="btn btn-primary btn-sm">Write To Console</button>
      </div>
    </div>
  </div>
</template>

<script setup>
//composition API using setup script
const {ref} = Vue;
const count = ref(1);

function writeToConsole() {
  console.log(count.value);
}
</script>

<style scoped>
.testStyle {
  color: red;
}
</style>